import type { ButtonHTMLAttributes, ReactNode } from "react";
import styles from "./LoginButton.module.css";

type LoginButtonMode = "primary" | "secondary";
type LoginButtonSize = "md" | "lg";
type LoginButtonAlign = "start" | "stretch";

type LoginButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> & {
  children: ReactNode;
  mode?: LoginButtonMode;
  size?: LoginButtonSize;
  align?: LoginButtonAlign;
  busy?: boolean;
};

export function LoginButton({
  align = "stretch",
  busy = false,
  children,
  className,
  size = "md",
  type = "button",
  mode = "primary",
  ...props
}: LoginButtonProps) {
  const classNames = [
    styles.button,
    styles[mode],
    styles[size],
    busy ? styles.busy : "",
    align === "start" ? styles.alignStart : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button className={classNames} type={type} {...props}>
      {children}
    </button>
  );
}
